import { getUserFromSession } from './utils';

function includes(container, value) {
  let returnValue = false;
  const pos = container.indexOf(value);
  if (pos >= 0) {
    returnValue = true;
  }
  return returnValue;
}

function check(roles, user) {
  if (!roles || !user) return false;
  if (roles.route) return includes(roles.route, user.role);
  if (Array.isArray(roles)) return includes(roles, user.role);
  return false;
}

const Acl = {
  mounted(el, binding) {
    // This is within a component
    const user = getUserFromSession();
    if (binding.instance.access) {
      if (!check(binding.instance.access[binding.arg], user)) {
        el.style.display = 'none';
      }
    } else if (binding.value) {
      // This is within the Menu / router
      if (binding.value[binding.arg] && !check(binding.value[binding.arg], user)) {
        el.style.display = 'none';
      } else if (binding.value.access && Array.isArray(binding.value.access) && !check(binding.value.access, user)) {
        el.style.display = 'none';
      } else if (binding.value.access && !check(binding.value.access[binding.arg], user)) {
        el.style.display = 'none';
      }
    } else {
      el.style.display = 'none';
    }
  },
};

export default Acl;
